import React from "react";
import Alert, { AlertColor } from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ReplyIcon from '@mui/icons-material/Reply';
import GetChallengeNoteViewModel from "./ViewModels/GetChallengeNoteViewModel";

interface IQaiChallengeNoteProps {
    view: string
    note: GetChallengeNoteViewModel
    setSelectedNote?: (challenge: GetChallengeNoteViewModel | null) => void
}

export default function QaiChallengeNote({ view, note, setSelectedNote }: IQaiChallengeNoteProps) {

    const getAlertType = (state: string): AlertColor => {
        if (state === 'Resolved') return 'success';
        if (state === 'Upheld') return 'info';
        if (state === 'Rejected') return 'error';
        return 'success';
    }

    return (
        <Grid key={note.id} border='solid 1px rgb(192, 192, 192)' borderRadius='4px' padding={1} marginBottom={1} size={12} sx={{ backgroundColor: '#efefef' }}>
            <Grid container justifyContent='space-between' size={12}>
                <Grid size={10}>
                    <Typography>{view !== 'Agent' ? `${note.name} - ${note.insertStamp}` : note.insertStamp} {note.type === 'Escalation' && ' - Escalation'}</Typography>
                </Grid>
                <Grid container justifyContent='center' size={2}>
                    {view === 'Team Leader' && note.type === 'Challenge' && setSelectedNote &&
                        <Grid>
                            <Button onClick={() => setSelectedNote(note)}>
                                <ReplyIcon color='primary' />
                            </Button>
                        </Grid>
                    }
                    {
                        view === 'QA' && note.type === 'Escalation' && setSelectedNote &&
                        <Grid>
                            <Button onClick={() => { setSelectedNote(note) }}>
                                Update escalation
                            </Button>
                        </Grid>
                    }
                </Grid>
            </Grid>
            {
                view === 'Agent' &&
                <>
                    <Grid size={12}><Typography><b>Section title: </b>{note.sectionTitle}</Typography></Grid>
                    <Grid size={12}><Typography><b>Question text: </b>{note.questionText}</Typography></Grid>
                </>
            }
            <Typography paddingTop={2}>{note.note}</Typography>
            {
                note.response &&
                <Grid size={12} marginTop={1}>
                    <Alert severity={getAlertType(note.state)}>
                        <AlertTitle>
                            {note.responderName} - {note.state}
                        </AlertTitle>
                        {
                            note.response
                        }
                    </Alert>
                </Grid>
            }
        </Grid>
    )
}